import { escapeRegExp } from 'lodash';

interface TagSelectFormatTagArgs {
  prefix: string;
  suffix: string;
  tag: string;
}

export const formatTag = ({ prefix, suffix, tag }: TagSelectFormatTagArgs) => {
  const re = new RegExp(
    `^${escapeRegExp(prefix)}|${escapeRegExp(suffix)}$`,
    'gi',
  );
  return prefix + tag.replace(re, '') + suffix;
};
